import { css } from 'emotion'

export const UploadWatcherListStyles = css`
  position: fixed;
  top: 0px;
  z-index: 1000;
`
